import styles from '../style.m.less';

export default function AriaLabel({ children, id = undefined }) {
    return (
        <OffscreenLabel id={id} ariaHidden="true">
            {children}
        </OffscreenLabel>
    );
}

function OffscreenLabel({ children, id = undefined, ariaHidden = false }) {
    return (
        <div className={styles.offScreen} id={id} aria-hidden={ariaHidden}>
            {children}
        </div>
    );
}
